const ModelRoutes = [
    {
        path: "/models",
        name: "Models",
        component: () =>
          import(
            /* webpackChunkName: "ModelsModule" */ "./views/Index.vue"
        ),
    },
    {
        path: "/models/create",
        name: "CreateModel",
        component: () =>
          import(
            /* webpackChunkName: "ModelsModule" */ "./views/Create.vue"
        ),
    },
  ];
  
  export default ModelRoutes;
  